import { useContext } from 'react';
import { useIntl } from 'react-intl';
import {
  DetailContext,
  PromptContext,
  useEventCallback,
  usePrompts,
} from '@eas/common-web';
import { Decision, DecisionText } from '@models';

const PROMPT_KEY = 'CONFIRM_COPY_ALL_ANONYMIZED_TEXTS';

const FIELDS: (keyof DecisionText)[] = [
  'introduction',
  'statement',
  'narration',
  'argumentation',
  'legalSentence',
  'abstract',
  'differentOpinion',
];

export function useConfirmCopyAllDialog() {
  const intl = useIntl();

  const { formRef } = useContext(DetailContext);
  const { testPrompt } = useContext(PromptContext);

  const handleConfirmDialog = useEventCallback(() => {
    if (!formRef) {
      return;
    }

    const text = (formRef?.getFieldValues() as Decision | undefined)?.text;

    FIELDS.forEach((fieldName) => {
      formRef?.setFieldValue(`anonymizedText.${fieldName}`, text?.[fieldName]);
    });
  });

  usePrompts([
    {
      key: PROMPT_KEY,
      dialogTitle: intl.formatMessage({
        id: 'ES__DECISIONS__ANONYMIZED_TEXT__CONFIRM_COPY_ALL__TITLE',
        defaultMessage: 'Upozornění',
      }),
      dialogText: intl.formatMessage({
        id: 'ES__DECISIONS__ANONYMIZED_TEXT__CONFIRM_COPY_ALL__TEXT',
        defaultMessage:
          'Skutečně chcete doplnit anonymizované texty textem rozhodnutí? Existující anonymizované texty budou přepsány.',
      }),
    },
  ]);

  const handleConfirmCopyAll = useEventCallback(() => {
    testPrompt({
      key: PROMPT_KEY,
      submitCallback: handleConfirmDialog,
    });
  });

  return { handleConfirmCopyAll };
}
